/* Dansk katalog for locale-autopilot-year-end-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'ap.yearEnd.title': 'Årsafslutning {{year}}',
  'ap.yearEnd.progress': 'Fremdrift i årsafslutningen',
  'ap.yearEnd.step.summary': 'Opsummering',
  'ap.yearEnd.step.review': 'Afklaringer',
  'ap.yearEnd.step.additions': 'Tillæg',
  'ap.yearEnd.step.final': 'Godkend',
  'ap.yearEnd.step.submission': 'Indsendelse',
  'ap.yearEnd.summaryTitle': 'Jeg har kontrolleret årsgrundlaget',
  'ap.yearEnd.summaryText': 'Du skal kun behandle de punkter, der ikke kan afklares sikkert ud fra dataene i Plumme.',
  'ap.yearEnd.approved': 'Kontrolleret og i orden',
  'ap.yearEnd.notApplicable': 'Ikke relevant',
  'ap.yearEnd.needsYou': 'Kræver behandling',
  'ap.yearEnd.startReview': 'Behandl {{count}} punkter',
  'ap.yearEnd.continueAdditions': 'Fortsæt til tillæg',
  'ap.yearEnd.questionCount': '{{total}} punkter tilbage',
  'ap.yearEnd.startReviewGroups': 'Behandl {{count}} grupper',
  'ap.yearEnd.groupCount': '{{total}} grupper tilbage',
  'ap.yearEnd.confirmReviewed': 'Jeg har kontrolleret og bekræfter',
  'ap.yearEnd.changeSomething': 'Jeg skal ændre noget',
  'ap.yearEnd.openWorkArea': 'Åbn det rigtige arbejdsområde',
  'ap.yearEnd.askAboutThis': 'Spørg AI om dette',
  'ap.yearEnd.handleCheck': 'Behandl',
  'ap.yearEnd.backToFlow': 'Tilbage til årsafslutning',
  'ap.yearEnd.openAsPage': 'Åbn som separat side',
  'ap.yearEnd.workAreaNote': 'Kontrolpunkterne opdateres ud fra det, du gør her.',
  'ap.yearEnd.reviewDone': 'Alle kontrolpunkter er afklaret',
  'ap.yearEnd.reviewDoneText': 'Nu kontrollerer vi, om du har andre oplysninger, som ikke findes i Plumme.',
  'ap.yearEnd.completeness': 'Fuldstændighedskontrol',
  'ap.yearEnd.anythingElse': 'Er der mere, der skal tilføjes?',
  'ap.yearEnd.anythingElseText': 'Beskriv det med dine egne ord. AI hjælper dig med at finde det rigtige område, men ændrer ingenting, før du har kontrolleret og godkendt forslaget.',
  'ap.yearEnd.additionPlaceholder': 'For eksempel: Vi købte en varebil i december, men fakturaen kom i januar.',
  'ap.yearEnd.findAddition': 'Find det rigtige tillæg',
  'ap.yearEnd.showAllAdditions': 'Vis alle tillæg',
  'ap.yearEnd.noMore': 'Nej, jeg har ikke mere at tilføje',
  'ap.yearEnd.finalControl': 'Slutkontrol',
  'ap.yearEnd.readyTitle': 'Årsafslutningen er klar til godkendelse',
  'ap.yearEnd.result': 'Årets resultat',
  'ap.yearEnd.backToReview': 'Behandl resterende punkter',
  'ap.yearEnd.completeAdditions': 'Fuldfør tillægskontrollen',
  'ap.yearEnd.closeYear': 'Godkend og afslut regnskabsåret',
  'ap.yearEnd.closing': 'Afslutter …',
  'ap.yearEnd.closedToast': 'Regnskabsåret er afsluttet.',
  'ap.yearEnd.saveError': 'Kunne ikke gemme årsafslutningen.',
  'ap.yearEnd.closeError': 'Kunne ikke afslutte regnskabsåret.',
  'ap.yearEnd.submissionTitle': 'Regnskabsåret er afsluttet',
  'ap.yearEnd.filedTitle': 'Årsafslutningen er færdig',
  'ap.yearEnd.submissionText': 'Fortsæt med skattemeldingen og årsregnskabet. Senere ændringer foretages indtil videre i fuld visning.',
  'ap.yearEnd.ai.title': 'Spørg SuperPlumma',
  'ap.yearEnd.ai.context': 'Samtalen følger denne årsafslutning og dette kontrolpunkt.',
  'ap.yearEnd.ai.empty': 'Spørg, hvorfor punktet er relevant, hvad et begreb betyder, eller beskriv noget, du tror mangler.',
  'ap.yearEnd.ai.placeholder': 'Hvad vil du vide?',
  'ap.yearEnd.ai.ask': 'Spørg',
  'ap.yearEnd.ai.thinking': 'Undersøger …',
  'ap.yearEnd.ai.error': 'Kunne ikke hente en forklaring lige nu.',
  'ap.yearEnd.ai.noAnswer': 'Jeg fandt ikke et sikkert svar. Åbn fuld visning for at kontrollere manuelt.',
  'ap.yearEnd.ai.proposalTitle': 'Forslag til skattepost',
  'ap.yearEnd.ai.assetGroup': 'Saldogruppe',
  'ap.yearEnd.ai.description': 'Beskrivelse',
  'ap.yearEnd.ai.openingValue': 'Indgående værdi',
  'ap.yearEnd.ai.acquisition': 'Nyanskaffelse',
  'ap.yearEnd.ai.improvement': 'Forbedring',
  'ap.yearEnd.ai.proceeds': 'Vederlag',
  'ap.yearEnd.ai.depreciation': 'Afskrivning',
  'ap.yearEnd.ai.amount': 'Beløb',
  'ap.yearEnd.ai.bookPrevious': 'Regnskabsmæssig værdi sidste år',
  'ap.yearEnd.ai.taxPrevious': 'Skattemæssig værdi sidste år',
  'ap.yearEnd.ai.bookCurrent': 'Regnskabsmæssig værdi i år',
  'ap.yearEnd.ai.taxCurrent': 'Skattemæssig værdi i år',
  'ap.yearEnd.ai.approvalNote': 'Intet gemmes, før du godkender. Posten valideres igen, når den gemmes.',
  'ap.yearEnd.ai.approve': 'Godkend og tilføj',
  'ap.yearEnd.ai.saved': 'Skatteposten er føjet til udkastet. Du kan beskrive flere oplysninger, hvis der mangler noget andet.',
  'ap.yearEnd.ai.savedToast': 'Skattepost tilføjet',
  'ap.yearEnd.ai.saveError': 'Kunne ikke gemme skatteposten.',
  'ap.yearEnd.ai.draftInProgress': 'Forslag under udarbejdelse',
  'ap.yearEnd.ai.cancelDraft': 'Afslut',
  'ap.agentName.bookkeeping': 'Bogføringsagenten',
  'ap.agentName.tax': 'Skatteagenten',
  'ap.agentName.annual': 'Årsregnskabsagenten',
  'ap.followup.bank': 'Bankafstemning',
  'ap.followup.title': 'Opfølgning',
  'ap.followup.countOne': '{{count}} punkt kræver opfølgning.',
  'ap.followup.countMany': '{{count}} punkter kræver opfølgning.',
  'ap.agent.tax.titleMissing': '{{count}} forudsætninger mangler før skattemeldingen',
  'ap.agent.annual.titleMissing': '{{count}} forudsætninger mangler før årsregnskabet',
  'ap.readiness.yearOpen': 'Regnskabsåret er ikke afsluttet',
  'ap.readiness.yearOpenSub': 'Årsafslutningen er ikke gennemført',
  'ap.readiness.inbox': '{{count}} bilag er ikke færdigbehandlet',
  'ap.readiness.inboxSub': 'Gør indbakken færdig før årsindsendelsen',
  'ap.readiness.bank': '{{count}} banklinjer er ikke færdigafstemt',
  'ap.readiness.bankSub': 'Gør bankafstemningen færdig',
  'ap.readiness.previousTax': 'Sidste skattemelding er ikke bekræftet indsendt',
  'ap.readiness.reviewYear': 'Kontrollér {{year}}',
  'ap.review.all': 'Alle',
  'ap.review.withVoucher': 'Med bilag',
  'ap.review.matched': 'Matchet',
  'ap.review.missingVoucher': 'Mangler bilag',
  'ap.review.needsChecking': 'Kræver kontrol',
  'ap.review.createsDeviation': 'Skaber afvigelse',
  'ap.review.upToDate': 'Ajour',
  'ap.review.approvedNotPosted': 'Godkendt · ikke bogført',
  'ap.review.blocked': 'Blokeret',
  'ap.review.ready': 'Klar',
  'ap.review.yourAccounts': 'Dit regnskab',
  'ap.review.exampleData': 'Eksempeldata',
  'ap.review.voucherLinked': '✓ Bilag tilknyttet',
  'ap.review.hideVoucher': 'Skjul bilag',
  'ap.review.showVoucher': 'Vis bilag',
  'ap.review.allVouchersLinked': 'Alle bilag er tilknyttet 🎉',
  'ap.review.deadline': 'Frist',
  'ap.review.readyForApproval': 'Klar til godkendelse',
  'ap.surface.fullscreen': 'Vis i fuld skærm',
  'ap.surface.exitFullscreen': 'Afslut fuld skærm',
  'ap.surface.voucherCount': '{{count}} bilag',
  'ap.surface.outsideMonth': '{{count}} uden for måneden',
  'ap.surface.accountsAndVouchers': 'Konto og bilag uden banklinje',
  'ap.yearEnd.bank.title': 'Bankafstemning {{year}}',
  'ap.yearEnd.bank.note': 'Vælg den måned, der skal kontrolleres for denne årsafslutning.',
  'ap.yearEnd.bank.openLines': '{{count}} åbne banklinjer',
  'ap.yearEnd.bank.missingStatements': '{{count}} bankkonti mangler kontoudtog',
  'ap.yearEnd.bank.done': 'Afstemt og arkiveret',
  'ap.yearEnd.bank.needsArchive': 'Kontrollér arkivering',
  'ap.yearEnd.bank.noStatement': 'Intet kontoudtog',
  'ap.yearEnd.backToWorkArea': 'Tilbage til {{title}}',
  'ap.surface.bankUploadUnavailable': 'Upload af kontoudtog er ikke tilgængelig endnu.',
  'ap.surface.bankReadError': 'Kunne ikke læse kontoudtoget.',
  'ap.surface.bankLoadErrorTitle': 'Afstemningen kunne ikke indlæses',
  'ap.surface.bankLoadErrorDetail': 'Genindlæs siden, eller åbn kontoudtoget fra Bank.',
  'ap.surface.assetMovedToExpense': 'Bilaget er flyttet ud af aktivkontrollen. Kontrollér konto og moms i bogføringslisten.',
  'ap.surface.assetSkipError': 'Kunne ikke springe registrering af aktiv over.',
  'ap.surface.assetTitle': 'Mulige driftsmidler',
  'ap.surface.assetSubtitle': '{{count}} bilag over beløbsgrænsen',
  'ap.surface.assetEmptyTitle': 'Ingen aktivforslag tilbage',
  'ap.surface.assetChooseHelp': 'Vælg, om bilaget skal registreres som driftsmiddel eller sendes tilbage til almindelig bogføringskontrol. Købet bogføres kun én gang.',
  'ap.surface.assetNotAsset': 'Ikke driftsmiddel',
  'ap.surface.inboxTitle': 'Bilagsindbakken',
});
